<template>
    <div class="">
        <div>
            <b-card no-body style="width: 100%;">
                <b-tabs pills card>
                    <b-tab lazy title="List Inventory" active>
                        <ListInventory :showbacker="false" />
                    </b-tab>
                    <b-tab lazy title="Add To Inventory" v-if="userDetails.userrole == 'admin' || userDetails.userrole == 'locationadmin' || userDetails.userrole == 'locationuser'">
                        <AddInventory :showbacker="false"  />
                    </b-tab>
                    

                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
    import ListInventory from "@/components/ListInventory"
    import AddInventory from "@/components/AddInventory"
 
    export default {
        name: "Inventory",
        components: {ListInventory, AddInventory},
        data: function(){
            return {
                userDetails: {properties: {}},
            }
        },
        methods: {
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
            }
        },

    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Inventory.vue